module.exports = __webpack_public_path__ + "static/media/house_big.7b9959cd.png";